<mat-card class="medicine-list-container">
  <div class="row">
    <div class="col-md-3">
      <mat-card-title>Medicine</mat-card-title>
    </div>
    <div class="col-md-9 text-end">
      <mat-form-field appearance="outline">
        <mat-label>Search using medicine name</mat-label>
        <input
          matInput
          placeholder="Start typing..."
          [formControl]="medicineNameInput"
        />
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <mat-paginator
    [length]="totalNumberOfMedicine"
    [pageIndex]="page - 1"
    [pageSize]="limit"
    [pageSizeOptions]="[10, 15, 20]"
    showFirstLastButtons
    (page)="onPageChange($event)"
    aria-label="Select page of prescriptions"
  >
  </mat-paginator>

  <div class="py-2">
    <mat-divider></mat-divider>
  </div>

  <table
    mat-table
    [dataSource]="medicineDataSource"
    class="medicine-list"
    matSort
    (matSortChange)="sortMedicine($event)"
  >
    <ng-container matColumnDef="name">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        sortActionDescription="Sort by Name"
        start="desc"
      >
        Name
      </th>
      <td mat-cell *matCellDef="let medicine">{{ medicine.name }}</td>
    </ng-container>

    <ng-container matColumnDef="barcode_prefix">
      <th mat-header-cell *matHeaderCellDef>Barcode prefix</th>
      <td mat-cell *matCellDef="let medicine">{{ medicine.barcode_prefix }}</td>
    </ng-container>

    <ng-container matColumnDef="active_ingredient">
      <th mat-header-cell *matHeaderCellDef>Active ingredient</th>
      <td mat-cell *matCellDef="let medicine">
        {{ medicine.active_ingredient }}
      </td>
    </ng-container>

    <ng-container matColumnDef="schedule_status">
      <th mat-header-cell *matHeaderCellDef>Schedule status</th>
      <td mat-cell *matCellDef="let medicine">
        {{ medicine.schedule_status }}
      </td>
    </ng-container>

    <ng-container matColumnDef="order_system">
      <th mat-header-cell *matHeaderCellDef>Order System</th>
      <td mat-cell *matCellDef="let medicine">
        <ng-container *ngIf="medicine.can_be_ordered !== null">
          <mat-checkbox [checked]="medicine.can_be_ordered" color="primary"></mat-checkbox>
        </ng-container>
      </td>
      
    </ng-container>

    <ng-container matColumnDef="created">
      <th mat-header-cell *matHeaderCellDef>Created</th>
      <td mat-cell *matCellDef="let medicine">
        {{ formatTime(medicine.created_at) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="updated">
      <th mat-header-cell *matHeaderCellDef>Updated</th>
      <td mat-cell *matCellDef="let medicine">
        {{ formatTime(medicine.updated_at) }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      (click)="openMedicine(row.id)"
      mat-row
      *matRowDef="let row; columns: displayedColumns"
    ></tr>
  </table>
</mat-card>
